import React from "react";
export const ViewContext: any = React.createContext(false);
